import React, { useState } from 'react';
import './Career.css';

const CareersPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    qualification: '',
    experience: '',
    mobile: '',
    jobPosition: '',
    resume: null,
    experienceCert: null,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    
    if (files) {
      const file = files[0];
      if (file && file.size > 1024 * 1024) {
        setErrors((prev) => ({
          ...prev,
          [name]: `${name === 'resume' ? 'Resume' : 'Experience certificate'} should be less than 1MB`,
        }));
        return;
      } else {
        setErrors((prev) => ({ ...prev, [name]: '' }));
      }
      setFormData((prevData) => ({ ...prevData, [name]: file }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.address.trim()) newErrors.address = 'Address is required';
    if (!formData.qualification.trim()) newErrors.qualification = 'Qualification is required';
    if (!formData.mobile.trim() || !/^\d{10}$/.test(formData.mobile))
      newErrors.mobile = 'Valid 10-digit mobile number is required';
    if (!formData.jobPosition) newErrors.jobPosition = 'Job position is required';
    if (!formData.resume) newErrors.resume = 'Resume is required';
    if (!formData.experienceCert) newErrors.experienceCert = 'Experience certificate is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      alert('Form submitted successfully!');
      setFormData({
        name: '',
        address: '',
        qualification: '',
        experience: '',
        mobile: '',
        jobPosition: '',
        resume: null,
        experienceCert: null,
      });
      setErrors({});
      // You can also reset file input fields manually here if needed
    }
  };

  return (
    <div className="careers-container">
      <div className="header-container">
        <h2>Join Our Team</h2>
        <div className="contact-info">
          <h3>Contact HR</h3>
          <p><strong>Name:</strong> Lakshmi Pradeepa M</p>
          <p><strong>Email:</strong> minervaprecisionhr@gmail.com</p>
          <p><strong>Phone:</strong> 0452-4567281</p>
        </div>
      </div>

      <p className="career-description">
        We are looking for talented and driven individuals to join our team. If you have the skills and passion to grow,
        we invite you to apply. Fill out the form below and attach your resume and experience certificate.
      </p>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} />
          {errors.name && <p className="error">{errors.name}</p>}
        </div>

        <div className="form-group">
          <label>Address</label>
          <textarea name="address" value={formData.address} onChange={handleChange}></textarea>
          {errors.address && <p className="error">{errors.address}</p>}
        </div>

        <div className="form-group">
          <label>Qualification</label>
          <input type="text" name="qualification" value={formData.qualification} onChange={handleChange} />
          {errors.qualification && <p className="error">{errors.qualification}</p>}
        </div>

        <div className="form-group">
          <label>Job Position</label>
          <select name="jobPosition" value={formData.jobPosition} onChange={handleChange}>
            <option value="">Select Job Position</option>
            <option value="Designer">Designer</option>
            <option value="CNC Specialist">CNC Specialist</option>
            <option value="Mechanical Engineer">Mechanical Engineer</option>
            <option value="Software Developer">Software Developer</option>
          </select>
          {errors.jobPosition && <p className="error">{errors.jobPosition}</p>}
        </div>

        <div className="form-group">
          <label>Experience</label>
          <div className="radio-group">
            {[0, 1, 2, 3, '3+'].map((exp) => (
              <label key={exp} className="radio-label">
                <input
                  type="radio"
                  name="experience"
                  value={exp}
                  checked={formData.experience === exp.toString()}
                  onChange={handleChange}
                />
                {exp} years
              </label>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label>Mobile Number</label>
          <input type="text" name="mobile" value={formData.mobile} onChange={handleChange} />
          {errors.mobile && <p className="error">{errors.mobile}</p>}
        </div>

        <div className="form-group">
          <label>Upload Resume (max 1MB)</label>
          <input type="file" name="resume" accept=".pdf, .doc, .docx" onChange={handleChange} />
          {errors.resume && <p className="error">{errors.resume}</p>}
        </div>

        <div className="form-group">
          <label>Upload Experience Certificate (max 1MB)</label>
          <input type="file" name="experienceCert" accept=".pdf, .doc, .docx" onChange={handleChange} />
          {errors.experienceCert && <p className="error">{errors.experienceCert}</p>}
        </div>

        <button type="submit">Submit Application</button>
      </form>
    </div>
  );
};

export default CareersPage;